import {
  fiscalCodeRegex,
  nameSurnameMoreCharactersRegex,
  regexNumericFiscalCode,
} from 'shell/constants/regex';
import * as yup from 'yup';
import { TypePractice } from 'practice/constants/type-practice';
import { RegisterOfficeVM } from 'shell/view-models/register-office-practice-vm';
import { TypeInitiative } from 'practice/constants/practice-management-step';

export const validationSchema = yup
  .object({
    applicantIsAccountholder: yup.boolean().nullable(),
    applicantData: yup
      .object()
      .nullable()
      .default({})
      .shape({
        generality: yup
          .object()
          .nullable()
          .default({})
          .shape({
            surname: yup
              .string()
              .nullable()
              .matches(nameSurnameMoreCharactersRegex, 'Campo non valido'),
            withoutSurname: yup.boolean().nullable(),
            name: yup
              .string()
              .nullable()
              .matches(nameSurnameMoreCharactersRegex, 'Campo non valido'),
            withoutName: yup.boolean().nullable(),
            gender: yup.string().nullable(),
            birthDate: yup.date().nullable().typeError('Data non valida'),
            isForeign: yup.boolean().nullable(),
            fiscalCode: yup.string().nullable(),
            // italian: yup
            //   .object()
            //   .nullable()
            //   .default({})
            //   .shape({ municipality: yup.object().nullable().default({}) }),
            // foreign: yup
            //   .object()
            //   .nullable()
            //   .default({})
            //   .shape({
            //     state: yup.object().nullable().default({}),
            //     municipality: yup.object().nullable().default({}),
            //   }),
          }),
        identificationDocument: yup
          .object()
          .nullable()
          .default({})
          .shape({
            documentNumber: yup.string().nullable(),
            issuedDate: yup.date().typeError('Data non valida').nullable(),
            isForeign: yup.boolean().nullable(),
            municipality: yup.object().nullable(),
            placeForeign: yup.string().nullable(),
          }),
      }),
    accountholderData: yup
      .object()
      .nullable()
      .default({})
      .shape({
        fiscalCode: yup.string().nullable(),
        identificationDocument: yup
          .object()
          .nullable()
          .default({})
          .shape({
            documentNumber: yup.string().nullable(),
            issuedDate: yup.date().typeError('Data non valida').nullable(),
            isForeign: yup.boolean().nullable(),
            municipality: yup.object().nullable(),
            placeForeign: yup.string().nullable(),
          }),
      }),
  })
  .test('accountholderData.fiscalCode', 'Formato non valido', (values) => {
    const castedValues = values as unknown as RegisterOfficeVM;
    const fiscalCode = castedValues?.accountholderData?.fiscalCode;

    if (fiscalCode) {
      if (regexNumericFiscalCode.test(fiscalCode) && fiscalCode?.length < 11) {
        return new yup.ValidationError(
          'Codice fiscale numerico non valido',
          undefined,
          'accountholderData.fiscalCode'
        );
      }
      if (!fiscalCodeRegex.test(fiscalCode)) {
        return new yup.ValidationError(
          'Codice fiscale non valido',
          undefined,
          'accountholderData.fiscalCode'
        );
      }
    }
    return true;
  })
  // controlli generalità del richiedente
  .test('surnameApplicant', 'Controllo', (values) => {
    const castedValues = values as unknown as RegisterOfficeVM;

    if (
      (castedValues.typePractice === TypePractice.Unavailable ||
        castedValues.typePractice === TypePractice.UntraceableCensus ||
        castedValues.typePractice === TypePractice.Emigration) &&
      castedValues.typeInitiative === TypeInitiative.idUfficio
    ) {
      // richiedente non obbligatorio
      return true;
    }

    if (
      !castedValues.applicantIsAccountholder &&
      !castedValues.applicantData?.generality?.withoutSurname &&
      !castedValues.applicantData?.generality?.surname
    ) {
      return new yup.ValidationError(
        'Campo obbligatorio',
        undefined,
        'applicantData.generality.surname'
      );
    }

    return true;
  })
  .test('nameApplicant', 'Controllo', (values) => {
    const castedValues = values as unknown as RegisterOfficeVM;

    if (
      (castedValues.typePractice === TypePractice.Unavailable ||
        castedValues.typePractice === TypePractice.UntraceableCensus ||
        castedValues.typePractice === TypePractice.Emigration) &&
      castedValues.typeInitiative === TypeInitiative.idUfficio
    ) {
      // richiedente non obbligatorio
      return true;
    }

    if (
      !castedValues.applicantIsAccountholder &&
      !castedValues.applicantData?.generality?.withoutName &&
      !castedValues.applicantData?.generality?.name
    ) {
      return new yup.ValidationError(
        'Campo obbligatorio',
        undefined,
        'applicantData.generality.name'
      );
    }

    return true;
  })
  .test('genderApplicant', 'Controllo', () => {
    // const castedValues = values as unknown as RegisterOfficeVM;

    // if (
    //   castedValues.typePractice === TypePractice.Unavailable &&
    //   castedValues.typeInitiative === TypeInitiative.idUfficio
    // ) {
    //   // richiedente non obbligatorio
    //   return true;
    // }

    // if (!castedValues.applicantIsAccountholder && !castedValues.applicantData?.generality?.gender) {
    //   return new yup.ValidationError(
    //     'Campo obbligatorio',
    //     undefined,
    //     'applicantData.generality.gender'
    //   );
    // }

    return true;
  })
  .test('birthDateApplicant', 'Controllo', () => {
    // const castedValues = values as unknown as RegisterOfficeVM;

    // if (
    //   castedValues.typePractice === TypePractice.Unavailable &&
    //   castedValues.typeInitiative === TypeInitiative.idUfficio
    // ) {
    //   // richiedente non obbligatorio
    //   return true;
    // }

    // if (
    //   !castedValues.applicantIsAccountholder &&
    //   !castedValues.applicantData?.generality?.birthDate
    // ) {
    //   return new yup.ValidationError(
    //     'Campo obbligatorio',
    //     undefined,
    //     'applicantData.generality.birthDate'
    //   );
    // }

    return true;
  })
  .test('italianApplicant', 'Controllo', () => {
    // const castedValues = values as unknown as RegisterOfficeVM;

    // if (
    //   castedValues.typePractice === TypePractice.Unavailable &&
    //   castedValues.typeInitiative === TypeInitiative.idUfficio
    // ) {
    //   // richiedente non obbligatorio
    //   return true;
    // }

    // if (
    //   !castedValues.applicantIsAccountholder &&
    //   !castedValues.applicantData?.generality?.isForeign &&
    //   !castedValues.applicantData?.generality?.italian?.municipality?.description
    // ) {
    //   return new yup.ValidationError(
    //     'Campo obbligatorio',
    //     undefined,
    //     'applicantData.generality.italian.municipality'
    //   );
    // }

    return true;
  })
  .test('foreignMunicipalityApplicant', 'Controllo', () => {
    // const castedValues = values as unknown as RegisterOfficeVM;

    // if (
    //   castedValues.typePractice === TypePractice.Unavailable &&
    //   castedValues.typeInitiative === TypeInitiative.idUfficio
    // ) {
    //   // richiedente non obbligatorio
    //   return true;
    // }

    // if (
    //   !castedValues.applicantIsAccountholder &&
    //   castedValues.applicantData?.generality?.isForeign &&
    //   !castedValues.applicantData?.generality?.foreign?.municipality?.description
    // ) {
    //   return new yup.ValidationError(
    //     'Campo obbligatorio',
    //     undefined,
    //     'applicantData.generality.foreign.municipality'
    //   );
    // }

    return true;
  })
  .test('foreignStateApplicant', 'Controllo', () => {
    // const castedValues = values as unknown as RegisterOfficeVM;

    // if (
    //   castedValues.typePractice === TypePractice.Unavailable &&
    //   castedValues.typeInitiative === TypeInitiative.idUfficio
    // ) {
    //   // richiedente non obbligatorio
    //   return true;
    // }

    // if (
    //   !castedValues.applicantIsAccountholder &&
    //   castedValues.applicantData?.generality?.isForeign &&
    //   !castedValues.applicantData?.generality?.foreign?.state?.id
    // ) {
    //   return new yup.ValidationError(
    //     'Campo obbligatorio',
    //     undefined,
    //     'applicantData.generality.foreign.state'
    //   );
    // }

    return true;
  })
  // controllo per codice fiscale
  .test('fiscalCodeApplicantData', 'Controllo', (values) => {
    const castedValues = values as unknown as RegisterOfficeVM;

    if (
      !castedValues.applicantIsAccountholder &&
      !(
        castedValues.accountholderData?.generality?.fiscalCode ||
        castedValues.applicantData?.generality?.fiscalCode
      )
    ) {
      return true;
    }

    if (
      !castedValues.applicantIsAccountholder &&
      castedValues.applicantData?.generality?.fiscalCode ===
        castedValues.accountholderData?.generality?.fiscalCode
    ) {
      return new yup.ValidationError([
        new yup.ValidationError(
          'Codice fiscale intestatario uguale a richiedente',
          undefined,
          'accountholderData.fiscalCode'
        ),
        new yup.ValidationError(
          'Codice fiscale richiedente uguale a intestatario',
          undefined,
          'applicantData.generality.fiscalCode'
        ),
      ]);
    }

    return true;
  })
  // controlli per documento del richiedente
  .test('documentNumberApplicant', 'Controllo', (values) => {
    const castedValues = values as unknown as RegisterOfficeVM;

    if (
      (castedValues.typePractice === TypePractice.Unavailable ||
        castedValues.typePractice === TypePractice.UntraceableCensus ||
        castedValues.typePractice === TypePractice.Emigration) &&
      castedValues.typeInitiative === TypeInitiative.idUfficio
    ) {
      // richiedente non obbligatorio
      return true;
    }

    if (
      !castedValues.applicantIsAccountholder &&
      castedValues.applicantData?.generality?.surname &&
      castedValues.applicantData?.generality?.name &&
      castedValues.applicantData?.generality?.fiscalCode &&
      !castedValues.applicantData?.identificationDocument?.documentNumber
    ) {
      return new yup.ValidationError(
        'Campo obbligatorio',
        undefined,
        'applicantData.identificationDocument.documentNumber'
      );
    }

    return true;
  })
  .test('issuedDateApplicant', 'Controllo', (values) => {
    const castedValues = values as unknown as RegisterOfficeVM;

    if (
      (castedValues.typePractice === TypePractice.Unavailable ||
        castedValues.typePractice === TypePractice.UntraceableCensus ||
        castedValues.typePractice === TypePractice.Emigration) &&
      castedValues.typeInitiative === TypeInitiative.idUfficio
    ) {
      // richiedente non obbligatorio
      return true;
    }

    if (
      !castedValues.applicantIsAccountholder &&
      castedValues.applicantData?.generality?.surname &&
      castedValues.applicantData?.generality?.name &&
      castedValues.applicantData?.generality?.fiscalCode &&
      !castedValues.applicantData?.identificationDocument?.issuedDate
    ) {
      return new yup.ValidationError(
        'Campo obbligatorio',
        undefined,
        'applicantData.identificationDocument.issuedDate'
      );
    }

    return true;
  })
  .test('municipalityApplicant', 'Controllo', (values) => {
    const castedValues = values as unknown as RegisterOfficeVM;

    if (
      (castedValues.typePractice === TypePractice.Unavailable ||
        castedValues.typePractice === TypePractice.UntraceableCensus ||
        castedValues.typePractice === TypePractice.Emigration) &&
      castedValues.typeInitiative === TypeInitiative.idUfficio
    ) {
      // richiedente non obbligatorio
      return true;
    }

    if (
      !castedValues.applicantIsAccountholder &&
      castedValues.applicantData?.generality?.surname &&
      castedValues.applicantData?.generality?.name &&
      castedValues.applicantData?.generality?.fiscalCode &&
      !castedValues.applicantData?.identificationDocument?.isForeign &&
      !castedValues.applicantData?.identificationDocument?.municipality?.description
    ) {
      return new yup.ValidationError(
        'Campo obbligatorio',
        undefined,
        'applicantData.identificationDocument.municipality'
      );
    }

    return true;
  })
  .test('placeForeignApplicant', 'Controllo', (values) => {
    const castedValues = values as unknown as RegisterOfficeVM;

    if (
      (castedValues.typePractice === TypePractice.Unavailable ||
        castedValues.typePractice === TypePractice.UntraceableCensus ||
        castedValues.typePractice === TypePractice.Emigration) &&
      castedValues.typeInitiative === TypeInitiative.idUfficio
    ) {
      // richiedente non obbligatorio
      return true;
    }

    if (
      !castedValues.applicantIsAccountholder &&
      castedValues.applicantData?.generality?.surname &&
      castedValues.applicantData?.generality?.name &&
      castedValues.applicantData?.generality?.fiscalCode &&
      castedValues.applicantData?.identificationDocument?.isForeign &&
      !castedValues.applicantData?.identificationDocument?.placeForeign
    ) {
      return new yup.ValidationError(
        'Campo obbligatorio',
        undefined,
        'applicantData.identificationDocument.placeForeign'
      );
    }

    return true;
  })
  // controlli per documento del intestatario
  .test('documentNumberAccountholder', 'Controllo', (values) => {
    const castedValues = values as unknown as RegisterOfficeVM;

    if (
      castedValues.applicantIsAccountholder &&
      castedValues.typeInitiative !== TypeInitiative.idUfficio &&
      !castedValues.accountholderData?.identificationDocument?.documentNumber
    ) {
      return new yup.ValidationError(
        'Campo obbligatorio',
        undefined,
        'accountholderData.identificationDocument.documentNumber'
      );
    }

    return true;
  })
  .test('issuedDateAccountholder', 'Controllo', (values) => {
    const castedValues = values as unknown as RegisterOfficeVM;

    if (
      castedValues.applicantIsAccountholder &&
      castedValues.typeInitiative !== TypeInitiative.idUfficio &&
      !castedValues.accountholderData?.identificationDocument?.issuedDate
    ) {
      return new yup.ValidationError(
        'Campo obbligatorio',
        undefined,
        'accountholderData.identificationDocument.issuedDate'
      );
    }

    return true;
  })
  .test('municipalityAccountholder', 'Controllo', (values) => {
    const castedValues = values as unknown as RegisterOfficeVM;

    if (
      castedValues.applicantIsAccountholder &&
      castedValues.typeInitiative !== TypeInitiative.idUfficio &&
      !castedValues.accountholderData?.identificationDocument?.isForeign &&
      !castedValues.accountholderData?.identificationDocument?.municipality?.description
    ) {
      return new yup.ValidationError(
        'Campo obbligatorio',
        undefined,
        'accountholderData.identificationDocument.municipality'
      );
    }

    return true;
  })
  .test('placeForeignAccountholder', 'Controllo', (values) => {
    const castedValues = values as unknown as RegisterOfficeVM;

    if (
      castedValues.applicantIsAccountholder &&
      castedValues.typeInitiative !== TypeInitiative.idUfficio &&
      castedValues.accountholderData?.identificationDocument?.isForeign &&
      !castedValues.accountholderData?.identificationDocument?.placeForeign
    ) {
      return new yup.ValidationError(
        'Campo obbligatorio',
        undefined,
        'accountholderData.identificationDocument.placeForeign'
      );
    }

    return true;
  });
